export const formatPercent = (value, { decimalPlaces = 2 } = {}) => {
    return new Intl.NumberFormat('en-US', {
        maximumFractionDigits: decimalPlaces,
        style: 'percent',
    }).format(value);
};
